import { AssigneeType, PersonPropertyValue, Property } from 'api/clients/PropertyClient'
import { MentionPrompt, ObjectsToLoad } from 'proseShared/prompts/MentionPrompt/MentionPrompt'
import { useState } from 'react'
import Foco from 'react-foco'
import { ArticleFlat } from 'types'
import { PropertySearch } from '../../PropertySearch/PropertySearch'
import Styles from '../PropertyValue.module.scss'

interface Props {
  assignee?: {
    id: string
    type: AssigneeType
  }
  property: Property
  selectedPropertyValues: PersonPropertyValue[]
  onSelect: (propertyValues: PersonPropertyValue[]) => void
  onCancel: () => void
}

const PersonEdit = ({ assignee, selectedPropertyValues, property, onSelect, onCancel }: Props) => {
  const [inputQuery, setInputQuery] = useState('')

  const handleOnSelect = (user: any) => {
    if (selectedPropertyValues.find((personValue) => personValue.id.toString() === user.userId)) {
      return onSelect(selectedPropertyValues)
    }

    if (property.meta?.allow_mentioning_multiple_people) {
      return onSelect([...selectedPropertyValues, { id: user.userId } as PersonPropertyValue])
    } else {
      return onSelect([{ id: user.userId } as PersonPropertyValue])
    }
  }

  return (
    <Foco onClickOutside={onCancel}>
      <div className={Styles.mentionEditContainer}>
        <div className={Styles.heading}>Value</div>
        <PropertySearch
          className={Styles.searchWrapper}
          placeholder={'Find a person...'}
          query={inputQuery}
          onChange={setInputQuery}
          onCancel={onCancel}
        />
        <div className={Styles.resultsList}>
          <MentionPrompt
            inputQuery={inputQuery}
            mentioningArticle={
              assignee &&
              ({
                id: assignee.id,
              } as ArticleFlat)
            }
            suggestRecentlyReadArticle={false}
            allowCreateNewFile={false}
            onSelect={handleOnSelect}
            dropdownWidth={'288px'}
            objectsToLoad={[ObjectsToLoad.Users]}
          />
        </div>
      </div>
    </Foco>
  )
}

export default PersonEdit
